/*
 * PKI.PdfSig — подписи ВНУТРИ PDF (PAdES, adbe.pkcs7.detached, штамп времени
 * документа ETSI.RFC3161).
 *
 * Подписанный PDF — это файл, у которого подписано всё, кроме одной «дыры»:
 * /ByteRange [a b c d] называет два куска [a, a+b) и [c, c+d), а между ними
 * лежит <hex> с CMS-подписью. Поэтому подпись находится по смещениям из самого
 * /ByteRange, без разбора объектов PDF — и работает на любом писателе, включая
 * повреждённые xref. Хеш считается по двум кускам ТЕМ ЖЕ алгоритмом, что
 * назван в подписи (ГОСТ для КриптоПро PDF, SHA-2 для Acrobat и DocuSign).
 *
 * Если c + d меньше длины файла — после подписи в файл что-то дописали
 * (инкрементальное обновление: ещё одна подпись, заполненное поле, пометка).
 * Подпись при этом верна для СВОЕЙ версии документа, и честный ответ — «вот
 * версия, которую подписали», байты [0, c+d), а не «файл испорчен».
 *
 * ES2019, UMD: window.PKI.PdfSig / module.exports.
 */
(function (root) {
    'use strict';

    function latin1(bytes, from, to) {
        var s = '', CH = 8192;
        for (var i = from; i < to; i += CH) {
            s += String.fromCharCode.apply(null, bytes.subarray(i, Math.min(to, i + CH)));
        }
        return s;
    }
    function hexToBytes(hex) {
        var clean = hex.replace(/[^0-9a-fA-F]/g, '');
        if (clean.length % 2) clean += '0';
        var out = new Uint8Array(clean.length >> 1);
        for (var i = 0; i < out.length; i++) out[i] = parseInt(clean.substr(i * 2, 2), 16);
        return out;
    }

    /* Строка PDF (…): экранирование и два кодирования — UTF-16BE с BOM
       (так пишут кириллицу) и PDFDocEncoding (≈ latin-1). */
    function pdfString(raw) {
        if (raw == null) return null;
        var bytes = [];
        for (var i = 0; i < raw.length; i++) {
            var ch = raw.charCodeAt(i);
            if (ch === 0x5c && i + 1 < raw.length) {
                var n = raw[i + 1];
                var map = { n: 10, r: 13, t: 9, b: 8, f: 12, '(': 40, ')': 41, '\\': 92 };
                if (map[n] !== undefined) { bytes.push(map[n]); i++; continue; }
                if (/[0-7]/.test(n)) {
                    var oct = /^[0-7]{1,3}/.exec(raw.substr(i + 1, 3))[0];
                    bytes.push(parseInt(oct, 8) & 255); i += oct.length; continue;
                }
                if (n === '\r' || n === '\n') { i++; if (n === '\r' && raw[i + 1] === '\n') i++; continue; }
                continue;
            }
            bytes.push(ch & 255);
        }
        if (bytes[0] === 0xfe && bytes[1] === 0xff) {
            var s = '';
            for (var k = 2; k + 1 < bytes.length; k += 2) s += String.fromCharCode((bytes[k] << 8) | bytes[k + 1]);
            return s;
        }
        if (bytes[0] === 0xef && bytes[1] === 0xbb && bytes[2] === 0xbf) {
            try { return new TextDecoder('utf-8').decode(new Uint8Array(bytes.slice(3))); } catch (e) { /* fallthrough */ }
        }
        return String.fromCharCode.apply(null, bytes);
    }
    function hexString(raw) {
        var b = hexToBytes(raw);
        if (b[0] === 0xfe && b[1] === 0xff) {
            var s = '';
            for (var k = 2; k + 1 < b.length; k += 2) s += String.fromCharCode((b[k] << 8) | b[k + 1]);
            return s;
        }
        return String.fromCharCode.apply(null, b);
    }
    /* Значение ключа в словаре-тексте: (строка), <hex> или /Имя. */
    function dictValue(dict, key) {
        var re = new RegExp('/' + key + '\\s*(\\((?:\\\\.|[^\\\\)])*\\)|<[0-9A-Fa-f\\s]*>|/[^\\s/<>\\[\\]()]+)');
        var m = re.exec(dict);
        if (!m) return null;
        var v = m[1];
        if (v[0] === '(') return pdfString(v.slice(1, -1));
        if (v[0] === '<') return hexString(v.slice(1, -1));
        return v.slice(1);
    }
    // D:YYYYMMDDHHmmSS+HH'mm'
    function pdfDate(s) {
        var m = /D:(\d{4})(\d{2})?(\d{2})?(\d{2})?(\d{2})?(\d{2})?([Zz+\-])?(\d{2})?'?(\d{2})?/.exec(s || '');
        if (!m) return null;
        var utc = Date.UTC(+m[1], (+m[2] || 1) - 1, +m[3] || 1, +m[4] || 0, +m[5] || 0, +m[6] || 0);
        if (m[7] === '+' || m[7] === '-') {
            var off = ((+m[8] || 0) * 60 + (+m[9] || 0)) * 60000;
            utc += m[7] === '+' ? -off : off;
        }
        return new Date(utc);
    }

    /* Начало словаря, внутри которого стоит pos: «<<» на глубине 0 при ходе назад. */
    function enclosingStart(text, pos) {
        var depth = 0, stop = Math.max(0, pos - 262144);
        for (var i = pos - 1; i > stop; i--) {
            var c = text.charCodeAt(i), p = text.charCodeAt(i - 1);
            if (c === 0x3e && p === 0x3e) { depth++; i--; }
            else if (c === 0x3c && p === 0x3c) { if (depth === 0) return i - 1; depth--; i--; }
        }
        return text.lastIndexOf('<<', pos);
    }
    /* Конец того же словаря: «>>» на глубине 0 при ходе вперёд; строки (…) пропускаются. */
    function enclosingEnd(text, pos) {
        var depth = 0, stop = Math.min(text.length, pos + 262144);
        for (var i = pos; i < stop - 1; i++) {
            var c = text.charCodeAt(i);
            if (c === 0x28) { // ( строка ) — со скобками и экранированием внутри
                var lvl = 1;
                for (i++; i < stop && lvl > 0; i++) {
                    var s = text.charCodeAt(i);
                    if (s === 0x5c) i++;
                    else if (s === 0x28) lvl++;
                    else if (s === 0x29) lvl--;
                }
                i--;
                continue;
            }
            var n = text.charCodeAt(i + 1);
            if (c === 0x3c && n === 0x3c) { depth++; i++; }
            else if (c === 0x3e && n === 0x3e) { if (depth === 0) return i; depth--; i++; }
        }
        return text.indexOf('>>', pos);
    }

    /**
     * Найти подписи в PDF.
     * → [{ byteRange:[a,b,c,d], cms:Uint8Array, subFilter, name, reason,
     *      location, contactInfo, signedAt:Date|null, signedLength,
     *      coversWholeFile, docTimestamp }]
     * Подписи возвращаются в порядке следования в файле (ранние — первыми).
     */
    function find(bytes) {
        var b = bytes instanceof Uint8Array ? bytes : new Uint8Array(bytes);
        var text = latin1(b, 0, b.length);
        var out = [], seen = {};
        var re = /\/ByteRange\s*\[\s*(\d+)\s+(\d+)\s+(\d+)\s+(\d+)\s*\]/g, m;
        while ((m = re.exec(text))) {
            var br = [+m[1], +m[2], +m[3], +m[4]];
            var key = br.join(',');
            if (seen[key]) continue;
            // Дыра между кусками обязана быть <hex>: иначе это не подпись, а
            // совпадение текста (например, /ByteRange внутри сжатого потока).
            var holeFrom = br[0] + br[1], holeTo = br[2];
            if (br[0] !== 0 || holeTo <= holeFrom || br[2] + br[3] > b.length) continue;
            if (b[holeFrom] !== 0x3c || b[holeTo - 1] !== 0x3e) continue;
            seen[key] = 1;
            // Хвост заполнителя (нули после CMS) НЕ обрезаем: BER-подпись сама
            // кончается на 00 00, а парсер и так читает объявленную длину и
            // помечает остаток как trailingBytes.
            var cms = hexToBytes(latin1(b, holeFrom + 1, holeTo - 1));
            // Словарь подписи — тот, что СОДЕРЖИТ дыру /Contents, с учётом вложенных
            // словарей. «Ближайшее << слева от /ByteRange» попадало во вложенный
            // /Prop_Build <</App <<…>>>>, если /ByteRange стоит в конце словаря
            // (SecCommerce, DSS Signature-P-DE_SCI-4): штамп документа ETSI.RFC3161
            // терял /SubFilter и проверялся как подпись — «документ изменён».
            var dictStart = enclosingStart(text, holeFrom);
            var tail = enclosingEnd(text, holeTo);
            var dict = text.slice(Math.max(0, dictStart), holeFrom) + text.slice(holeTo, tail < 0 ? holeTo + 2000 : tail + 2);
            var subFilter = dictValue(dict, 'SubFilter');
            out.push({
                byteRange: br,
                cms: cms,
                subFilter: subFilter,
                name: dictValue(dict, 'Name'),
                reason: dictValue(dict, 'Reason'),
                location: dictValue(dict, 'Location'),
                contactInfo: dictValue(dict, 'ContactInfo'),
                signedAt: pdfDate(dictValue(dict, 'M')),
                signedLength: br[2] + br[3],
                coversWholeFile: br[2] + br[3] === b.length,
                docTimestamp: subFilter === 'ETSI.RFC3161'
            });
        }
        out.sort(function (x, y) { return x.signedLength - y.signedLength; });
        return out;
    }

    /** Байты двух подписанных кусков — для хеша (или весь «подписанный» PDF). */
    function signedRanges(bytes, sig) {
        var b = bytes instanceof Uint8Array ? bytes : new Uint8Array(bytes);
        var br = sig.byteRange;
        return [b.subarray(br[0], br[0] + br[1]), b.subarray(br[2], br[2] + br[3])];
    }
    /** Версия документа, которую подписали: [0, c+d). */
    function signedRevision(bytes, sig) {
        var b = bytes instanceof Uint8Array ? bytes : new Uint8Array(bytes);
        return b.subarray(0, sig.signedLength);
    }

    /** Похож ли файл на PDF с подписью (дёшево, по сырым байтам). */
    function looksSigned(bytes) {
        var b = bytes instanceof Uint8Array ? bytes : new Uint8Array(bytes);
        if (!(b[0] === 0x25 && b[1] === 0x50 && b[2] === 0x44 && b[3] === 0x46)) return false;
        return /\/ByteRange\s*\[/.test(latin1(b, 0, b.length));
    }

    var API = { find: find, signedRanges: signedRanges, signedRevision: signedRevision, looksSigned: looksSigned, _pdfDate: pdfDate, _pdfString: pdfString };
    if (typeof module !== 'undefined' && module.exports) module.exports = API;
    if (root) { root.PKI = root.PKI || {}; root.PKI.PdfSig = API; }
})(typeof window !== 'undefined' ? window : (typeof globalThis !== 'undefined' ? globalThis : null));
